"use client";

import { useEffect, useState } from "react";
import { ZoomIn } from "lucide-react";
import { useAppDispatch, useAppSelector } from "@/hooks/useStore";
import { getActivityGalleryList } from "@/store/controller/activityGallery.controller";
import { ImageLightbox } from "./imageLightbox";

export function KegiatanSection() {
  const dispatch = useAppDispatch();
  const activities = useAppSelector((state) => state.activityGallery.list);
  const [hovered, setHovered] = useState<number | null>(null);
  const [lightbox, setLightbox] = useState<number | null>(null);

  useEffect(() => {
    dispatch(getActivityGalleryList({ limit: 12 }));
  }, [dispatch]);

  if (activities.length === 0) return null;

  return (
    <section id="kegiatan" className="py-20 bg-gray-50">
      {lightbox !== null && (
        <ImageLightbox
          src={activities[lightbox].image}
          alt={activities[lightbox].description ?? activities[lightbox].title}
          title={activities[lightbox].title}
          onClose={() => setLightbox(null)}
          onPrev={() => setLightbox((previousIndex) => (previousIndex! - 1 + activities.length) % activities.length)}
          onNext={() => setLightbox((previousIndex) => (previousIndex! + 1) % activities.length)}
          hasPrev={lightbox > 0}
          hasNext={lightbox < activities.length - 1}
        />
      )}
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-14">
          <span className="inline-block text-green-700 font-semibold text-sm uppercase tracking-widest mb-3">
            Dokumentasi
          </span>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-3">
            Galeri <span className="text-green-700">Kegiatan</span>
          </h2>
          <div className="w-14 h-1 bg-yellow-400 rounded mx-auto mb-4" />
          <p className="text-gray-500 max-w-xl mx-auto">
            Potret keseharian dan berbagai kegiatan santri SMAIT Ihsanul Fikri Mungkid.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {activities.map((activity, activityIndex) => (
            <div
              key={activity.id}
              className={`relative rounded-2xl overflow-hidden group cursor-pointer h-64 ${activity.span === "col-span-2" ? "sm:col-span-2" : ""}`}
              onMouseEnter={() => setHovered(activityIndex)}
              onMouseLeave={() => setHovered(null)}
              onClick={() => setLightbox(activityIndex)}
              style={{ backgroundColor: "#e5e7eb" }}
            >
              <img
                src={activity.image}
                alt={activity.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div
                className="absolute inset-0 transition-opacity duration-300"
                style={{
                  background: "linear-gradient(to top, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.1) 60%, transparent 100%)",
                  opacity: hovered === activityIndex ? 1 : 0.7,
                }}
              />
              <div className="absolute bottom-4 left-4 right-4">
                <h3 className="text-white font-bold text-lg leading-tight">{activity.title}</h3>
                {activity.description && <p className="text-white/70 text-sm mt-0.5">{activity.description}</p>}
              </div>
              <div
                className={`absolute top-4 right-4 w-9 h-9 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center text-white transition-all duration-200 ${
                  hovered === activityIndex ? "opacity-100 scale-100" : "opacity-0 scale-75"
                }`}
              >
                <ZoomIn size={16} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
